export function shouldGenerateEngines(): boolean {
  // TODO: make it smart and actually check if there are any non-ssg pages
  return true
}
